/**
 * App Store
 * Manages global UI state using Zustand
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
    // Sidebar
    sidebarOpen: boolean;
    sidebarCollapsed: boolean;

    // Theme
    theme: 'light' | 'dark' | 'auto';

    // Actions
    toggleSidebar: () => void;
    setSidebarOpen: (open: boolean) => void;
    setSidebarCollapsed: (collapsed: boolean) => void;
    setTheme: (theme: 'light' | 'dark' | 'auto') => void;
}

export const useAppStore = create<AppState>()(
    persist(
        (set) => ({
            sidebarOpen: true,
            sidebarCollapsed: false,
            theme: 'auto',

            toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

            setSidebarOpen: (open) => set({ sidebarOpen: open }),

            setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

            setTheme: (theme) => set({ theme }),
        }),
        {
            name: 'app-storage',
            partialize: (state) => ({
                sidebarCollapsed: state.sidebarCollapsed,
                theme: state.theme,
            }),
        }
    )
);
